import { render, staticRenderFns } from "./_roles_form.vue?vue&type=template&id=ea0fc04c"
import script from "./_roles_form.vue?vue&type=script&lang=js"
export * from "./_roles_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports